import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "src/store";

export type ThemeKey =
  "indigo" | "emerald" | "violet" | "rose" | "slate" | "liftoff" | "midnight";

interface ThemeState {
  current: ThemeKey;
}

function loadInitialTheme(): ThemeKey {
  try {
    const saved = localStorage.getItem("ui.theme");
    if (
      saved === "indigo" ||
      saved === "emerald" ||
      saved === "violet" ||
      saved === "rose" ||
      saved === "slate" ||
      saved === "liftoff" ||
      saved === "midnight"
    ) {
      return saved;
    }
  } catch {}
  return "indigo";
}

const initialState: ThemeState = {
  current: loadInitialTheme(),
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme(state, action: PayloadAction<ThemeKey>) {
      state.current = action.payload;
      try {
        localStorage.setItem("ui.theme", action.payload);
      } catch {}
    },
  },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;

export const selectTheme = (state: RootState) => state.theme.current;
